export default __webpack_public_path__ + "static/media/four.86f19ebc.jpg";